import { default as Item , View } from './item'
import listComponent from '@/util/proto/listComponent'
import { createDict } from '@/util/dicts'
import global from '@/util/mixin/global'
export default {
  extends: listComponent,
  mixins:[global],
  data() {
    return {
      columns: [
        {
          type: 'index',
          width: 65,
          title: '序号',
          align: 'center'
        },
        {
          title: '公告标题',
          key: 'title',
          minWidth: 150,
        },
        {
          title: '发布主体',
          key: 'pubName',
          minWidth: 150,
        },
        {
          title: '发布时间',
          key: 'releaseDatetimeText',
          minWidth: 160,

        },
        {
          title: '状态',
          key: 'statusText',
          minWidth: 100,

        },
        {
          title: '操作',
          key: 'action',
          width: 200,
          align: 'center',
          fixed:'right',
          render: (h, params) => {
            let node = []
            let { status , pubId , pubUserType } = params.row
            if( status == 1 && this.$auth.access('setting.notice.query') ){
              node.push( <a on-click={()=>this.view(params)}>查看</a> )
            }
            //未发布 且 发布人是 管理员 或者 当前登录用户时
            else if(
              status == 0 && (
                this.isAdmin ||
                (this.isCompany && pubUserType == 5 && pubId == this.subjectId) ||
                (this.isSupervisor && pubUserType == 4 && pubId == this.subjectId)
              )
            ){
              node.push( <a v-permission="setting.notice.update" on-click={()=>this.edit(params)}>编辑</a> )
              node.push( <a v-permission="setting.notice.delete" on-click={()=>this.remove(params)}>删除</a> )
            }
           
            return this.$utils.link(node,<Divider type="vertical" />)
          }
        }
      ],
      data: [],
      loading: false,
      params: {
        title:null,
        pubName:null,
        time:[]
      },
    }
  },
  created() {
    this.def = { ...this.params }
    this.search()
  },

  methods: {

    search() {
      let searchParams = {...this.params}
      let publishTime = searchParams.time
      if(publishTime && publishTime.length == 2 && publishTime[0] && publishTime[1]){
        searchParams.beginTime = publishTime[0]
        searchParams.endTime = publishTime[1]
      }

      delete searchParams.time

      let params = { search: searchParams, pageSize: this.page.pageSize, pageNum: this.page.pageNum }
      this.loading = true
      this.$request.notices(params).then(resp => {
        this.loading = false
        if (!resp.code) {
          this.data = this.$utils.conv(resp.data.list || [], { 'releaseDatetime': 'datetime','status':'publishStatus'})
          this.page.total = resp.data.total || 0
        }
      })
    },

    view({row}){
      this.$dialog({
        width:600,
        paddingless:true,
        render:(h)=>{
          return <View id={row.id} />
        }
      })
    },
    edit({ row }) {
      this.$refs['item'].init(row.id)
    },

    create() {
      this.$refs['item'].init(0)
    },

    toggle({row}){
      let tip = row.status !=0 ? '启用' : '禁用'
      this.$ui.confirm(this.$request.noticeToggle, `确定${tip} ${row.gfName} ？`)(row.id).then(resp => {
        if (!resp.code) {
          this.$Message.success('操作成功')
          this.search()
        } else {
          this.$Message.error(resp.msg)
        }
      })
    },

    remove({ row }) {
      this.$ui.confirm(this.$request.noticeDelete, `确定删除 ${row.title} ？`)(row.id).then(resp => {
        if (!resp.code) {
          this.$Message.success('操作成功')
          this.search()
        } else {
          this.$Notice.error({
            title: '删除发生错误',
            desc: resp.msg,
          });
        }
      })
    },

    reset() {
      this.$utils.fill(this.params, this.def)
      this.search()
    },

    handleUpdate() {
      this.modalVisible = false
      this.search()
    },
  },

  render(){
    const { create,reset, search, columns , loading , page , data , handleUpdate,params , handleSearchChange} = this
    const slots = {
      action:()=>{
        return <Button v-permission="setting.notice.insert" type="primary" icon="md-add" on-click={create}>新增</Button>
      }
    }
    return (
      <sl-page>
        <div class='page-filter border-bottom'>
          <sl-search on-reset={reset} on-search={search} scopedSlots={slots}>
            <sl-search-item>
              <Input v-model={params.title} placeholder="请输入公告名称" />
            </sl-search-item>
            <sl-search-item>
              <Input v-model={params.pubName} placeholder="请输入发布主体" />
            </sl-search-item>
            <sl-search-item>
              <DatePicker v-model={params.time} type="datetimerange" style="width:100%;" placeholder="请选择发布时间"></DatePicker>
            </sl-search-item>
          </sl-search>
        </div>
        <div class="pg-bd">
          <sl-table loading={loading} page={page} columns={columns} data={data} on-change={this.$tableChange}></sl-table>
        </div>
        <Item ref="item" on-update={handleUpdate} />
      </sl-page>
    )
  }
}
